import { AccentPicker } from './AccentPicker';
import { GeminiKeyForm } from './GeminiKeyForm';
import { HouseholdForm } from './HouseholdForm';
import { useMe } from '../../store/queryHooks';
import styles from './IndstillingerPage.module.css';

export function IndstillingerPage() {
  const me = useMe();
  if (me.isPending) return <div>Indlæser…</div>;
  if (me.isError || !me.data) return <div>Kunne ikke hente husstand.</div>;
  return (
    <div className={styles.wrap}>
      <GeminiKeyForm isSet={me.data.gemini_key_set} />
      <HouseholdForm />
      <AccentPicker />
    </div>
  );
}
